// Imports
import React from 'react';
//Contents
import Link from "../../menu-link/LinkHelper.jsx";

export default function ProjectElement({ data, navigate })
{
    // if (typeof window !== 'undefined') console.log('ProjectElement render', data);

    return (
        <li className="project-element">
            <Link
                navigate={navigate}
                className='link card-project-link'
                href={data.slug}
                aria-label="See the project"
            >
                <div className="content-project-element">
                    <div className="image-project-element-inner">
                        <img className="image-project-element" src={data.imageList} alt={data.title || ''} loading="lazy" />
                    </div>
                    <h2 className="title-project-element">{data.title}</h2>
                </div>
            </Link>
        </li>
    )
}